

import SecureStorage from "secure-web-storage";
const CryptoJS = require("crypto-js");
const SECRET_KEY = process.env.REACT_APP_STORAGE;
const secureStorage = new SecureStorage(localStorage, {
    hash: function hash(key) {       
        key = CryptoJS.SHA256(key, SECRET_KEY);
        return key.toString();
    },
    encrypt: function encrypt(data) {
        data = CryptoJS.AES.encrypt(data, SECRET_KEY);
        data = data.toString();
        return data;
    },
    decrypt: function decrypt(data) {
        data = CryptoJS.AES.decrypt(data, SECRET_KEY);
        data = data.toString(CryptoJS.enc.Utf8);
        return data;
    }
});
export const saveItem = (key, state) => {
    try {
        secureStorage.setItem(key, state);
    } catch (e) {
        console.error('Error saving state', e);
    }
}

export const getItem = (key) => {
    try {
        const serializedState = secureStorage.getItem(key);
        if (serializedState === null) {
            return undefined;
        }
        return serializedState;
    } catch (e) {
        return undefined;
    }
}

export const removeItem = (key) => {
    secureStorage.removeItem(key);
}
